import { LoyaltyService } from 'rpc/model/squareup/buyerportal/merchantportal/loyalty/service';
import rpc from './rpc';

const loyaltyClient = LoyaltyService.create(rpc());

export default loyaltyClient;
